import styled from "styled-components";

export const CardsSection = styled.section`
  display: grid;
  grid-template-columns: 1.45fr 1fr;
  gap: ${({ theme }) => theme.spacing(4)};
  width: 100%;
  max-width: 78rem;
  margin: ${({ theme }) => theme.spacing(8)} auto;
  padding: 0 ${({ theme }) => theme.spacing(2)};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    max-width: 32rem;
    margin: ${({ theme }) => theme.spacing(5)} auto;
  }
`;

const Card = styled.article`
  position: relative;
  height: 38rem;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  background: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 30rem;
  }
`;

export const AlertCard = styled(Card)``;

export const AlertContent = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 3.75rem 3rem 0;
  text-align: center;

  h2 {
    max-width: 30rem;
    margin: 0;
    color: ${({ theme }) => theme.colors.orange};
    font-size: 2.1rem;
    line-height: 1.15;
  }

  p {
    max-width: 31rem;
    margin: 0.9rem 0 1.65rem;
    color: ${({ theme }) => theme.colors.deepDarkBlue};
    font-size: 1rem;
    line-height: 1.35;
  }

  button {
    padding: 0.75rem 1.55rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 2rem 1.25rem 0;

    h2 {
      font-size: 1.45rem;
    }

    p {
      margin-bottom: 1rem;
      font-size: 0.85rem;
    }
  }
`;

export const AlertGradient = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  height: 50%;
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  background: linear-gradient(180deg, #ff9d00 0%, #ffd263 100%);
`;

export const AlertImage = styled.img`
  position: absolute;
  bottom: -0.6rem;
  left: 50%;
  z-index: 2;
  width: auto;
  max-width: 92%;
  height: 58%;
  object-fit: contain;
  object-position: center bottom;
  transform: translateX(-50%);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: auto;
    max-width: 108%;
    height: 55%;
  }
`;

export const AppCard = styled(Card)``;

export const AppContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 53%;
  padding: 3rem 2rem 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.vividBlue} 0%,
    #318cf4 100%
  );
  color: ${({ theme }) => theme.colors.white};
  text-align: center;

  strong {
    font-size: 1rem;
  }

  h2 {
    max-width: 18rem;
    margin: 0.8rem 0;
    font-size: 2.1rem;
    line-height: 1.15;
  }

  p {
    max-width: 24rem;
    margin: 0;
    font-size: 1rem;
    line-height: 1.35;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 2rem 1.25rem 1rem;

    h2 {
      font-size: 1.45rem;
    }

    p,
    strong {
      font-size: 0.82rem;
    }
  }
`;

export const AppImageStyled = styled.img`
  position: absolute;
  right: -2%;
  bottom: -0.4rem;
  z-index: 2;
  width: auto;
  max-width: 100%;
  height: 64%;
  object-fit: contain;
  object-position: right bottom;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    right: -4%;
    height: 60%;
  }
`;

export const StoreButtons = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  z-index: 3;
  display: flex;
  gap: 0.35rem;

  button img {
    width: 8.5rem;
    height: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    bottom: 1rem;
    left: 1rem;

    button img {
      width: 7rem;
    }
  }
`;
